module.exports = __webpack_public_path__ + "static/img/GettyImages-514412831.50ded46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/GettyImages-514412831.jpg
// module id = 0B0H
// module chunks = 0